<template>
  <div class="history-detail px-4">
    <div style="max-height: 520px; overflow: auto">
      <history-details-key-value-list :values="keyValuePairs" />
    </div>

    <div style="display: flex; justify-content: center; width: 100%" v-if="item.actionItemLink">
      <a href="#" class="my-1" role="button" @click.prevent="openActionItem">
        <i class="fa fa-list-alt"/> <span> Open Action Item</span>
      </a>
    </div>
    <hr style="margin: 0;">
    <div class="description mt-2">
      <p class=" p-2" style="white-space: pre-wrap">{{ item.description }}</p>
    </div>

    <div v-if="isCobraRateChange">
      <cobra-rate-change-details  :json-string="item.bag.json"/>
    </div>

    <email-details v-if="item.eventType === 'Email'" :bag="item.bag" />

    <paper-mail-details v-if="item.eventType === 'PaperMail'" :bag="item.bag" />
  </div>

</template>

<script>
import {amfx} from "../../framework/utils/amfx";
import {romeApi} from "../../framework";
import fileDownload from "js-file-download";
import moment from "moment";
import CobraRateChangeDetails from "./CobraRateChangeDetails.vue";
import EmailDetails from "./EmailDetails.vue";
import {formatters} from "../../framework";
import HistoryDetailsKeyValueList from "./HistoryDetailsKeyValueList.vue";
import PaperMailDetails from "./PaperMailDetails.vue";
import { cobraConstants } from "../../cobra/cobra-constants";

export default {
  components: {PaperMailDetails, HistoryDetailsKeyValueList, CobraRateChangeDetails, EmailDetails},
  inject: ["closeModal"],
  props: {
    item: { type: Object, required: true },
    showUser: { type: Boolean, required: true }
  },
  data() {
    return {
      call: null,
    }
  },
  computed: {
    title() { return 'Event Details'; },
    hasCallLog() { return this.call && !!this.call.log; },
    buttons() {
      let buttons = [];
      if(isCobraPaperLetter(this.item)) {
        if (this.item.bag.postGridLetterStatus === cobraConstants.POSTGRID_STATUS.ReadyToPrint || [cobraConstants.MAIL_STATUS.New, cobraConstants.MAIL_STATUS.Failed].includes(this.item.bag.status)) {
          buttons.push({ name: 'Cancel Letter', onClick: this.cancelPaperLetter });
        }
        buttons.push({ name: 'Resend Letter', onClick: this.resendPaperLetter });
      }

      return [...buttons, { name: '$Close' }]
    },
    goToEntityTitleText() {
      return `Go to ${this.item.entityType}`;
    },
    fileDownloadText() {
      if (this.item.bag.fileName) return this.item.bag.fileName;

      const storageFile = this.item.bag.storageFile;
      if (storageFile && storageFile.fileName) return storageFile.fileName;

      return "Download File";
    },
    isCobraRateChange(){
      return !!this.item.bag.json && this.item.bag.json.toLowerCase().includes("changesbyrateyear");
    },
    mailParams(){
      if (!this.item.bag.mailParams) return;

      return Object.entries( this.item.bag.mailParams).filter(x => x[0] != 'postmarkRequires').map(([key, value]) => {
        return { key, value };
      });
    },
    keyValuePairs() {
      const kvps = [];

      if (this.item.entityLink) kvps.push({ key: this.item.entityType, value: 'Test', clickAction: () => this.openLink(this.item.entityLink) });
      if (this.showUser) kvps.push({ key: "User", value: this.item.userName });
      kvps.push({ key: "Date", value: formatters.date(this.item.changeDate) });

      if (this.item.eventType === 'ActionItem') {
        if (this.item.bag.itemType) kvps.push({ key: "Action Item Type", value: this.item.bag.itemType });
        if (this.item.bag.itemSubType) kvps.push({ key: "Action Item Sub-Type", value: this.item.bag.itemSubType });
      }

      if (this.call) {
        kvps.push({ key: "Issue", value: this.call.issue });
        kvps.push({ key: "Outcome", value: this.call.outcome });
        if (this.hasCallLog) kvps.push({ key: "Call Log", value: "Download", clickAction: () => this.downloadCallLog(), icon: "fa-download" });
        else kvps.push({ key: "Call Log", value: "Not Available" });
      }

      if (this.item.bag.storageFileId) {
        kvps.push({ key: "File", value: "Download", clickAction: this.downloadFile, icon: "fa-download" });
      }

      return kvps;
    }
  },
  methods: {
    ...amfx.map("accounts", "updateStatus"),
    downloadCallLog(){
      fileDownload(this.call.log, `${moment(this.call.createdDate).format('MMDDYYYY')}_CallLog.txt`);
    },
    async resendPaperLetter() {
      let item = this.item;

      await cobraApi.post(`letter/${item.entityId}/resend/${item.bag.paperMailMessageId}`);

      toastService.success(`Resent letter successfully`);

      return {
        triggerRefresh: true
      }
    },
    async cancelPaperLetter() {
      let item = this.item;

      await cobraApi.post(`letter/${item.entityId}/cancel/${item.bag.paperMailMessageId}`);

      toastService.success(`Cancelled letter successfully`);

      return {
        triggerRefresh: true
      }
    },
    async downloadFile() {
      if (!this.item.bag.storageFileId) return;
      await romeApi.download(`/StorageFile/${this.item.bag.storageFileId}`);
    },
    openLink(link) {
      location.href = link;
      this.closeModal();
    },
    openActionItem() {
      if (!this.item.actionItemLink) return;
      this.item.actionItemLink();
      this.closeModal();
    }
  },
  async created() {
    if (this.item.bag.isAgentless) {
      this.call = await romeApi.get(`/interaction/${this.item.key}/associated-call`);
    }
  },
};

function isCobraPaperLetter(item) {
  return item.eventType == 'PaperMail' && item.bag.templateName && item.bag.templateName.startsWith('cobra');
}
</script>

<style lang="scss" scoped>

.history-detail {
  overflow: auto;
  max-height: 600px;
}

.description p {
  background-color: #f0f0f0;
  overflow-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/history/modals/HistoryDetail.vue